import { render, staticRenderFns } from "./reviewStars.vue?vue&type=template&id=6d459985"
import script from "./reviewStars.vue?vue&type=script&lang=js"
export * from "./reviewStars.vue?vue&type=script&lang=js"
import style0 from "./reviewStars.vue?vue&type=style&index=0&id=6d459985&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports